import React, { useCallback } from "react";
import Button from "@mui/material/Button";
import { connect, useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { devLogin } from "../../redux/actions/login.action";


const styles = {
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "80vh",
        padding: "16px",
    },
    button: {
        backgroundColor: "#FFFFFF",
        color: "#000000",
        fontWeight: "bold",
        padding: "8px 16px",
        border: "1px solid",
        borderRadius: "4px",
        boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
        marginBottom: "16px",
        minHeight: "48px",
        width: "280px",
    },
    googleIcon: {
        marginRight: "8px",
        width: "24px",
        height: "24px",
        fill: "#FFC107",
    },
    userInfo: {
        textAlign: "center",
    },
    logoutButton: {
        backgroundColor: "#FF3D00",
        color: "#FFFFFF",
        fontWeight: "bold",
        padding: "8px 16px",
        borderRadius: "4px",
        cursor: "pointer",
        marginTop: "16px",
        "&:hover": {
            backgroundColor: "#D32F2F",
        },
    },
};

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);

    const handleDevLogin = useCallback(() => {
        dispatch(devLogin()).then(() => {
            navigate("/");
        });
    }, [dispatch, navigate]);

    const openGoogleLoginPage = useCallback(() => {
        const googleAuthUrl = "https://accounts.google.com/o/oauth2/v2/auth";

        const scope = [
            "https://www.googleapis.com/auth/userinfo.email",
            "https://www.googleapis.com/auth/userinfo.profile",
        ].join(" ");

        const VITE_GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
        const VITE_GOOGLE_REDIRECT_URL_ENDPOINT = import.meta.env.VITE_GOOGLE_REDIRECT_URL_ENDPOINT;
        const params = new URLSearchParams({
            response_type: "code",
            client_id: VITE_GOOGLE_CLIENT_ID,
            redirect_uri: `${VITE_GOOGLE_REDIRECT_URL_ENDPOINT}/google`,
            prompt: "select_account",
            access_type: "offline",
            scope,
            state: JSON.stringify({ redirect: location.state ? location.state.from : "/" }),
        });

        window.location.href = `${googleAuthUrl}?${params}`;
    }, [location]);

    if (user?.username) {
        navigate("/");
        return null;
    }

    return (
        !user?.username && (
            <div style={styles.root}>
                <div
                    style={{
                        margin: 20,
                        border: '1px solid #000',
                        width: '400',
                        textAlign: 'center',
                        borderRadius: 20,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: 5
                    }}
                >
                    <img src="/letter-m.png" alt="Morphle" style={{ width: 100, height: 100 }} />
                    <div style={{ fontSize: 30, fontWeight: '400', padding: '10px' }}>
                        Morphle OneMap
                    </div>
                    <div style={{ fontSize: 24, marginBottom: '20px' }}>Login</div>

                    <Button
                        style={styles.button}
                        onClick={openGoogleLoginPage}
                        variant="contained"
                    >
                        <img
                            style={{ width: 24, height: 24, marginRight: 10 }}
                            src="/google-g-logo.svg"
                            alt="Google Logo"
                        />
                        Sign in with Google
                    </Button>
                    {import.meta.env.VITE_DEV_MODE === 'true' && (
                        <Button
                            style={{
                                ...styles.button,
                                backgroundColor: "#FF9800",
                                borderColor: "#FF9800",
                            }}
                            onClick={handleDevLogin}
                            variant="contained"
                        >
                            Dev Login (Skip OAuth)
                        </Button>
                    )}
                </div>
            </div>
        )
    );
};

const mapStateToProps = (state) => ({
    accessToken: Cookies.get('access_token'),
});

export default connect(mapStateToProps)(Login);

